import React, { Component } from 'react';
import Header from '../common/Header';
import Input from '../../ui/input/Input';
import AuthService from '../auth/AuthService';

class Login extends Component {
    constructor(){
        super();
        this.state = {
            username: '',
            password: ''
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new AuthService();
    }

    onChange = (event) => {
        this.setState({
          [event.target.name]: event.target.value
        })
    }

    render() {
        return (
            <div>
                <Header user="" />
                <div className="content-wrapper">
                    <div className="loginBox">
                        <form>
                            <div className="loginBox__fieldswrapper">
                                <Input
                                    className="login-item"
                                    placeholder="Brugernavn"
                                    name="username"
                                    type="text"
                                    value={this.state.username}
                                    onChange={this.handleChange}
                                />
                                <Input
                                    className="login-item"
                                    placeholder="Adgangskode"
                                    name="password"
                                    type="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                />
                                <div>
                                    <input
                                        className="button large sienna login"
                                        value="Log ind"
                                        type="button"
                                        onClick={(e) => this.handleFormSubmit(e)}
                                        />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="loginText">
                        Login til Trossamfundsregistret, hvor det er muligt for anerkendte trossamfund og menigheder at indberette oplysninger til By-, Land- og Kirkeministeriet.
                    </div>
                    <div className="loginInformation" style={{marginTop: '3rem'}}>
                        <div style={{float: 'left'}}>
                            <img src="/images/assets/info.svg" alt="Login information" />
                        </div>
                        <div style={{float: 'left', marginLeft: '1em', width: '90%'}}>
                        <p style={{marginTop: '.5em'}}>Anerkendte trossamfund og menigheder, der er registreret i CVR-registret, vil modtage brugernavn og adgangskode i trossamfundets digitale postkasse. Den digitale postkasse kan tilgås på www.virk.dk.</p>
                        <p>Anerkendte trossamfund og menigheder, der ikke er registreret i CVR-registret, vil modtage brugernavn og adgangskode via ordinær post til trossamfundets adresse.</p>
                        <p>Ved manglende eller glemt brugernavn eller adgangskode kontakt da By-, Land- og Kirkeministeriet på tlf. nr. 33 92 33 90, med sikker post via jeres digitale postkasse, der kan tilgås på www.virk.dk eller med ordinær post til By-, Land- og Kirkeministeriet, Frederiksholms Kanal 21, 1220 København K.</p>
                        <p>Al kommunikation med anerkendte trossamfund og menigheder foregår via sikker post.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillMount(){
        if(this.Auth.loggedIn())
            this.props.history.replace('/admin/organizations');
    }

    handleChange(e){
        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }

    handleFormSubmit(e){
        e.preventDefault();
        this.Auth.login(this.state.username,this.state.password)
            .then(res =>{
               this.props.history.replace('/admin/');
            })
            .catch(err =>{
                alert(err);
            })
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/modules/user/Login.js